module.exports = __webpack_public_path__ + "img/imagen4.da5d3cc2.png";